import { render, staticRenderFns } from "./ProcedureWindows.vue?vue&type=template&id=23ec77e7&scoped=true&"
import script from "./ProcedureWindows.vue?vue&type=script&lang=js&"
export * from "./ProcedureWindows.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureWindows.vue?vue&type=style&index=0&id=23ec77e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec77e7",
  null
  
)

export default component.exports